import { render, staticRenderFns } from "./AccountControl.vue?vue&type=template&id=5e999bdc"
import script from "./AccountControl.vue?vue&type=script&lang=js"
export * from "./AccountControl.vue?vue&type=script&lang=js"
import style0 from "./AccountControl.vue?vue&type=style&index=0&id=5e999bdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports